import Glider from './glider.min.js';
window.addEventListener('load', function () {
  var glider = document.querySelector('.glider');

  if (glider) {
    new Glider(glider, {
      slidesToShow: 'auto',
      slidesToScroll: 'auto',
      itemWidth: 200,
      skipTrack: true,
      draggable: true,
      resizeLock: false,
      dragVelocity: 1,
      arrows: {
        prev: '.glider-prev',
        next: '.glider-next'
      }
    });
  }
});